/*******************************************************************************
TRIGGER A SUB NAVIGATION LIST
Handles a click on a link with sub-navigation.
*******************************************************************************/

export default function triggerSubNav(e) {
    const $activeNav = $(e.currentTarget);
    const activeNavName = $activeNav.data('name');
    const parentName = $activeNav.data('parent');
    const $filterSet = $activeNav.parents('.filter-links');
    const $filterWrapper = $filterSet.parents('.filter-links-wrapper');
    const $title = $filterWrapper.siblings('.filter-links-title');
    const navTitle = (parentName) ? `${parentName}: ${activeNavName}` : `${activeNavName}`;
    const moreButtonText = $filterSet.data('moreButton') || 'More Filters';

    // Add the sub nav class to the wrapper (used for adjusting styles)
    $filterWrapper.addClass('is-showing-sub-nav');

    // Hide all the top level filters
    $filterSet.find('.filter-link').addClass('hide');

    // Show the sub-items for the active filter
    $(`.is-sub-link[data-parent="${activeNavName}"]`).removeClass('hide');

    // Add a button that lets you go back to the parent level filters (if it's not already there)
    if ($filterSet.siblings('.more-filter-links').length === 0) {
        $filterSet.before(`<button class="more-filter-links">${moreButtonText}</button>`);
    }

    // Scroll the sub nav filter all the way to the left to start
    $filterSet[0].scrollLeft = 0;

    // Remove any existing secondary titles
    $title.find('.filter-links-sub-title').remove();

    // Add a secondary title to the filter title that shows which parent filter is active
    $title.html(`${$title.html()}<span class="filter-links-sub-title">${navTitle}</span>`);
}
